import React, { useState } from 'react';

export default function ConfigTab({ config, updateConfig }) {
  const [form, setForm] = useState({
    speech: { ...config.speech },
    webhookUrl: config.webhookUrl,
    editWebhookUrl: config.editWebhookUrl,
    addFaceWebhookUrl: config.addFaceWebhookUrl,
    deleteFaceWebhookUrl: config.deleteFaceWebhookUrl,
    listFacesWebhookUrl: config.listFacesWebhookUrl,
    resetTimeoutSeconds: config.resetTimeoutSeconds,
    retryDelaySeconds: config.retryDelaySeconds,
    captureIntervalSeconds: config.captureIntervalSeconds,
    autoScanEnabled: config.autoScanEnabled,
    adminPassword: config.adminPassword,
  });
  const [saved, setSaved] = useState(false);

  const set = (path, value) => {
    setForm(prev => {
      const next = { ...prev };
      if (path.includes('.')) {
        const [parent, child] = path.split('.');
        next[parent] = { ...prev[parent], [child]: value };
      } else {
        next[path] = value;
      }
      return next;
    });
    setSaved(false);
  };

  const handleSave = () => {
    updateConfig(form);
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  return (
    <div>
      {/* Voz */}
      <p className="config-section-title">Síntesis de voz</p>

      <div className="config-field">
        <label>Velocidad de voz</label>
        <div className="slider-row">
          <input
            type="range"
            min="0.5"
            max="1.5"
            step="0.05"
            value={form.speech.rate}
            onChange={e => set('speech.rate', parseFloat(e.target.value))}
          />
          <span className="slider-value">{form.speech.rate.toFixed(2)}</span>
        </div>
      </div>

      <div className="config-field">
        <label>Volumen de voz</label>
        <div className="slider-row">
          <input
            type="range"
            min="0"
            max="1"
            step="0.05"
            value={form.speech.volume}
            onChange={e => set('speech.volume', parseFloat(e.target.value))}
          />
          <span className="slider-value">{form.speech.volume.toFixed(2)}</span>
        </div>
      </div>

      <div className="config-field">
        <label>Idioma de voz</label>
        <select value={form.speech.lang} onChange={e => set('speech.lang', e.target.value)}>
          <option value="es-ES">Español (es-ES)</option>
          <option value="ca-ES">Català (ca-ES)</option>
          <option value="en-US">English (en-US)</option>
        </select>
      </div>

      {/* Webhooks */}
      <p className="config-section-title" style={{ marginTop: '1.5rem' }}>Conexiones</p>

      <div className="config-field">
        <label>URL webhook reconocimiento facial</label>
        <input
          type="text"
          value={form.webhookUrl}
          onChange={e => set('webhookUrl', e.target.value)}
        />
      </div>

      <div className="config-field">
        <label>URL webhook edición Google Sheets</label>
        <p className="field-hint">Opcional. Necesario para editar actividades desde la app.</p>
        <input type="text" value={form.editWebhookUrl} onChange={e => set('editWebhookUrl', e.target.value)} placeholder="https://..." />
      </div>

      <p className="config-section-title" style={{ marginTop: '1.5rem' }}>Gestión de usuarios</p>

      <div className="config-field">
        <label>URL webhook añadir cara</label>
        <p className="field-hint">POST /add-face — del workflow n8n-gestion-usuarios</p>
        <input type="text" value={form.addFaceWebhookUrl} onChange={e => set('addFaceWebhookUrl', e.target.value)} placeholder="https://...add-face" />
      </div>
      <div className="config-field">
        <label>URL webhook eliminar cara</label>
        <p className="field-hint">POST /delete-face — del workflow n8n-gestion-usuarios</p>
        <input type="text" value={form.deleteFaceWebhookUrl} onChange={e => set('deleteFaceWebhookUrl', e.target.value)} placeholder="https://...delete-face" />
      </div>
      <div className="config-field">
        <label>URL webhook listar caras</label>
        <p className="field-hint">GET /list-faces — del workflow n8n-gestion-usuarios</p>
        <input type="text" value={form.listFacesWebhookUrl} onChange={e => set('listFacesWebhookUrl', e.target.value)} placeholder="https://...list-faces" />
      </div>

      {/* Comportamiento */}
      <p className="config-section-title" style={{ marginTop: '1.5rem' }}>Tiempos</p>

      <div className="config-field">
        <label>Modo de escaneo</label>
        <div className="toggle-row">
          <span className={!form.autoScanEnabled ? 'toggle-label active' : 'toggle-label'}>Manual</span>
          <button
            type="button"
            className={`toggle-btn ${form.autoScanEnabled ? 'on' : 'off'}`}
            onClick={() => set('autoScanEnabled', !form.autoScanEnabled)}
          >
            <span className="toggle-thumb" />
          </button>
          <span className={form.autoScanEnabled ? 'toggle-label active' : 'toggle-label'}>Automático</span>
        </div>
        <p className="field-hint">
          {form.autoScanEnabled
            ? 'La cámara captura automáticamente cada pocos segundos.'
            : 'El usuario debe pulsar el botón para capturar.'}
        </p>
      </div>

      <div className="config-field">
        <label>Intervalo de captura (segundos)</label>
        <p className="field-hint">Cada cuántos segundos la cámara hace una foto para intentar identificar.</p>
        <div className="slider-row">
          <input
            type="range"
            min="1"
            max="10"
            step="0.5"
            value={form.captureIntervalSeconds}
            onChange={e => set('captureIntervalSeconds', parseFloat(e.target.value))}
          />
          <span className="slider-value">{form.captureIntervalSeconds}s</span>
        </div>
      </div>

      <div className="config-field">
        <label>Segundos mostrando el resultado (cara identificada)</label>
        <p className="field-hint">Tiempo que se muestra el saludo antes de volver a la cámara.</p>
        <div className="slider-row">
          <input
            type="range"
            min="0"
            max="60"
            step="1"
            value={form.resetTimeoutSeconds}
            onChange={e => set('resetTimeoutSeconds', parseInt(e.target.value, 10))}
          />
          <span className="slider-value">{form.resetTimeoutSeconds}s</span>
        </div>
      </div>

      <div className="config-field">
        <label>Espera entre intentos (cara no detectada)</label>
        <p className="field-hint">Segundos de pausa antes de volver a intentar cuando no se detecta ninguna cara.</p>
        <div className="slider-row">
          <input
            type="range"
            min="1"
            max="30"
            step="1"
            value={form.retryDelaySeconds}
            onChange={e => set('retryDelaySeconds', parseInt(e.target.value, 10))}
          />
          <span className="slider-value">{form.retryDelaySeconds}s</span>
        </div>
      </div>

      {/* Seguridad */}
      <p className="config-section-title" style={{ marginTop: '1.5rem' }}>Seguridad</p>

      <div className="config-field">
        <label>Contraseña del panel admin</label>
        <input
          type="password"
          value={form.adminPassword}
          onChange={e => set('adminPassword', e.target.value)}
        />
      </div>

      <button className="config-save-btn" onClick={handleSave}>
        Guardar cambios
      </button>
      {saved && <p className="config-saved-msg">✓ Cambios guardados correctamente</p>}
    </div>
  );
}
